export interface ITeamsStore {
  currentTeam?: any;
  teams: any[];
  invitations: any[];
  summaries: any[];
  currentMemberId?: string;
}

export const teamsStore = {
  teams: [],
  invitations: [],
  summaries: [],
  memberId: undefined,
};
